<template>


<TopBar />

<div class="main-container">

<SideBar />

<div class="main"> 


<section>

<div class="container" style="border-bottom: solid 1px #f0f0f0; padding-top: 10px; padding-bottom: 10px;">

<div class="row">

<div class="col-md-6 pt-3">


</div>



</div>

</div>

</section>


<section style="padding-top:200px;" v-if="show_spinner==true">

<div style="text-align:center;">

<h6 class="text-secondary">Please wait...</h6>
<div class="spinner-border  text-info"></div>
</div>

</section>



<section v-if="show_spinner==false">
  
<div class="container">

    <div class="row">

    <div class="col-md-12">

      <div class="shadow  p-3 mt-3" style="border: solid 1px  #d7f1ff; border-radius: 15px; height: 500px;">

       
        <l-map
    style="height: 500px; width: 100px;"
    :zoom="zoom"
    :center="center"
  >
    <l-tile-layer
      :url="tileUrl"
      :attribution="attribution"
    />
    <l-marker
      v-for="(location, index) in locations"
      :key="index"
      :lat-lng="[location.lat, location.lng]"
      @click="onMarkerClick(location)"
    />
  </l-map>

        
      </div>
      
    </div>
    
  </div>

  
  
  
</div>

</section>




</div>




</div>


<Footer />

</template>


<script setup>
import { ref } from 'vue';
import {
  LMap,
  LTileLayer,
  LMarker,
} from 'vue3-leaflet';

const zoom = ref(6);
const center = ref([0.0236, 37.9062]); // Kenya center coordinates

const tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
const attribution = '&copy; OpenStreetMap contributors';

const locations = ref([
  { name: 'Nairobi', lat: -1.2921, lng: 36.8219 },
  { name: 'Mombasa', lat: -4.0435, lng: 39.6682 },
  { name: 'Kisumu', lat: -0.0917, lng: 34.7679 },
]);

function onMarkerClick(location) {
  alert(`You clicked on ${location.name}`);
}
</script>



<script>

import Header from './layouts/Header'
import SideBar from './layouts/SideBar'
import TopBar from './layouts/TopBar'
import Footer from './layouts/Footer'
import axios from 'axios'

export default{
name : 'home',
components : { Header, SideBar, TopBar, Footer  },
data(){
return{
show_spinner : true
}
},

methods : {

},

created(){

setTimeout((data)=>{
this.show_spinner = false
}, 3000)
}


}

</script>






